import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class PersonNameService {

    public getShortendedName(firstName: string, lastName: string): string {
        if (!(firstName?.length) && !(lastName?.length)) return "";
        if (!(firstName?.length)) return lastName;
        if (!(lastName?.length)) return firstName;
        return `${firstName} ${lastName[0]}.`;
    }

    public getFullName(firstName: string, lastName: string): string {
        if (!(firstName?.length) && !(lastName?.length)) return "";
        if (!(firstName?.length)) return lastName;
        if (!(lastName?.length)) return firstName;
        return `${firstName} ${lastName}`;
    }
}